import axios from "axios";
import { LOGOUT_MAINTAIN, MAINTAINANCE } from "./helper";
import { toast } from "react-toastify";
export const APP_BASE_URL =
  window.location.hostname === "omnisync.omni-united.com"
    ? "https://omnisync.omni-united.com/api/v1"
    : `http://${window.location.hostname}:3000/api/v1`;
// export const HTTP_TOKEN = window.location.hostname === "eportal.omni-united.com" || window.location.hostname === "omnisync.omni-united.com" ? "0e8d9697b7c2d29e4994e5ac8f1ed3b0" : "f64a78eb75fb63cf4c135f5211301491";

const endpoint = axios.create({
  baseURL: APP_BASE_URL,
});

let toastShown = false;

function showSessionExpiredToast() {
  if (!toastShown) {
    toastShown = true;
    localStorage.clear();
    window.location.href = "/";
    toast.error("Session expired. Please login again.");
    setTimeout(() => (toastShown = false), 3000); // allow again after 3s
  }
}

endpoint.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if (
      localStorage.getItem("token") &&
      (config?.method?.toLowerCase() === "get" ||
        config?.method?.toLowerCase() === "delete" || config?.method?.toLowerCase() === "post")
    )
      config.headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export const initInterceptors = (dispatch, state) => {
  endpoint.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      if (response.data?.under_maintainance) {
        localStorage.clear();
        dispatch({
          type: MAINTAINANCE,
          payload: response.data?.under_maintainance,
        });
        dispatch({
          type: LOGOUT_MAINTAIN,
          payload: true,
        });
      } else {
        if (state?.orders?.products?.maintainace) {
          dispatch({
            type: MAINTAINANCE,
            payload: false,
          });
        }
      }

      if (
        !Number.isNaN(Number(localStorage.getItem("expiresAt"))) &&
        Number(localStorage.getItem("expiresAt")) < new Date().getTime()
      ) {
        localStorage.clear();
        dispatch({
          type: LOGOUT_MAINTAIN,
          payload: true,
        });
      }
      return response;
    },
    function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      // Global 401 Unauthorized Handling
      if (error.response?.status === 401) {
        showSessionExpiredToast();
      }
      return Promise.reject(error);
    }
  );
};

export default endpoint;
